<div #d3LineChart class="d3_line_chart"></div>
<ul #chartLegend class="chart_legend">
  <ng-container *ngFor="let label of dataLines; index as i">
    <li (click)="selectedLegend === i ? legendClick() : legendClick(i)" [ngClass]="{ active: selectedLegend === i }">
      <i [ngStyle]="{ 'background-color': colors.colorSeries[colorIndex[i]] }"></i>
      <span>{{ i + 1 }}: {{ label }}</span>
    </li>
  </ng-container>
</ul>
